<template>
  <div>
    <v-container fluid>
      <v-row>
        <!-- Cards con comentarios -->
        <v-col v-for="comment in dComplaintComments" :key="comment.commentId" cols="12" sm="6" md="4" lg="3" class="heightAuto">
          <v-card class="postCard" height="100%">
            <v-card-title class="ma-0 px-2 py-1">
              <p class="fs14 fcC1 font-weight-bold pb-1 text-truncate px-4 pt-3 mb-0" color="datPrimary">
                {{comment.userName}}
              </p>
              <p class="fs12 fcT2 py-0 px-4 mb-0 text-lowercase fLetter">
                {{fDateFormat(comment.creationDate) }}
              </p>
            </v-card-title>
            <v-card-text>
              <p class="fs12 fcT2 text-lowercase mb-0 fLetter px-2">
                {{comment.description}}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Card de nuevo comentario -->
        <v-col cols="12" sm="6" md="4" lg="3" class="heightAuto">
          <v-card class="addCard d-flex align-center justify-center" height="100%" @click="fOpenModal">
            <v-icon size="40">mdi-plus</v-icon>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modal nueva nota -->
    <datModal v-if="dShowModal" v-model="dShowModal" :pWidth="700" :pTitle="$t('datFormsTitles.newComment')">
      <eComplaintNewComment :pComplaintInfo="pComplaintInfo"  @close="fCloseModal"/>
    </datModal>
  </div>

</template>
<script>

import datModal from '@/components/datModal'
import eComplaintNewComment from '@/components/EComplaints/complaintDetail/modals/eComplaintNewComment'

//Servicios y mixins 
import mxCanalDenuncias from '@/mixins/mxCanalDenuncias.vue'
import ServiceEcomplaints from '@/services/srv-eComplaints'
import ServiceEcomplaintsPublic from '@/services/srv-eComplaintsPublic'

export default {
  components: {
    eComplaintNewComment,
    datModal
  },
  mixins: [ mxCanalDenuncias],

  props: {
    pComplaintInfo:{
      type: Object,
      required: false
    },
    pShowSnackbar:{
      type: String,
      default: 'BOTH' // SON PARENT BOTH
    }
  },
  mounted(){
    this.fGetComplaintComments()
  },
  data () {
    return {
      dItemKey: 'commentId',
      dComplaintComments: [],
      dShowModal: false,
      dExternalOrigin: localStorage.getItem("externOrigin") 
    }
  },
  methods: {

    // Recupera la lista de comentarios asociados a la denuncia
    fGetComplaintComments(){
      const payload = {
        complaintId: this.pComplaintInfo.complaintId
      }

      if (this.dExternalOrigin){
        ServiceEcomplaintsPublic.getComplaintComments(payload).then(response =>{
          this.dComplaintComments = response.dataRes
          this.dTotalRows = response.numReg
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }else{
        ServiceEcomplaints.getComplaintComments(payload).then(response =>{
          this.dComplaintComments = response.dataRes
          this.dTotalRows = response.numReg
        }).catch(error => {
          this.fSnackbarError(error, this.pShowSnackbar)
        })
      }
    },

    // Cierra la modal de nuevo comentario y actualzia la lista de ocmentarios is es necesario
    fCloseModal(update){
      if(update){
        this.fGetComplaintComments()
      }
      this.dShowModal = false
    },

    // Abre la modal de nuevo comentario
    fOpenModal(){
      this.dShowModal = true
    }
  },
  watch:{
    dPagination() {
      this.fGetComplaintComments()
    },
    dSearch(){
			clearTimeout(this.dCurrentSearchTime)
			this.dCurrentSearchTime = setTimeout(() => {
        this.dPagination.page = 1
				this.fGetNotes()
			}, 1000)
    },
  }
}
</script>
